<template>
  <div class="project-appoint-index">
    <div
      class="project-appoint-index-box"
      @click="itemClicked(item)"
      v-for="(item, index) of list"
      :key="index"
    >
      <van-image width="76px" height="76px" :src="item.KPTB" />
      <div class="project-index-right">
        <div class="project-index-title">{{ item.KPBT }}</div>
        <div class="project-index-content">
          {{ item.KPMS }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api/appoint'
import moduleMixins from '@/mixins/moduleMixins'

export default {
  name: 'ProjectAppointIndex',
  components: {},
  mixins: [moduleMixins],
  props: {},
  data() {
    return {
      list: [],
      title: ''
    }
  },
  watch: {},
  computed: {
    navTitle() {
      return this.title
    }
  },
  methods: {
    itemClicked(val) {
      this.$store.commit('form/setFormData', {XMWT: val})
      this.$router.push({
        name: 'ProjectAppointDetail'
      })
    },
    loadData() {
      api.getAppointCard().then(res => {
        res.forEach(element => {
          //图片要加前缀
          element.KPTB = '/sinfoweb' + element.KPTB
        })
        this.list = res
        console.log(res)
      })
    }
  },
  created() {},
  mounted() {
    this.title = this.$route.query.title
    this.loadData()
  }
}
</script>
<style lang="scss" scoped>
.project-appoint-index {
  padding: 15px;
  .project-appoint-index-box {
    display: flex;
    background: #ffffff;
    box-shadow: 0px 2px 5px 0px rgba(124, 130, 140, 0.2);
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 22px 36px 22px 15px;
    .project-index-right {
      padding-left: 20px;
      .project-index-title {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 21px;
        margin-bottom: 10px;
      }
      .project-index-content {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 21px;
      }
    }
  }
}
</style>
